import PropTypes from 'prop-types';
import React from 'react';
import ExtraCardBehavior from '../shared/ExtraCardBehavior';
import Modal from 'components/Modal';
import FullScreenButton from '../shared/FullScreenButton';
import FullScreenIframe from '../../../components/FullScreenIframe';
import FullScreenModalHeader from '../shared/FullScreenModalHeader';
import PdpNotice from 'components/PdpNotice';

class Mason extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {isOpen: false};
    this.handleRequestModalClose = this.handleRequestModalClose.bind(this);
    this.handleFullScreenClick = this.handleFullScreenClick.bind(this);
  }

  handleRequestModalClose() {
    this.setState({
      isOpen: false,
    });
  }

  handleFullScreenClick() {
    this.setState({
      isOpen: true,
    });
  }

  render() {
    return (
      <div
        style={Object.assign(
          {padding: '8px 16px', overflow: 'auto'},
          this.props.style
        )}
      >
        <iframe
          src={`/mason/kpi/${this.props.card.id}`}
          style={Object.assign(
            {border: 'none', minHeight: 500, width: '100%'},
            this.props.frameStyle
          )}
        />
        <PdpNotice cardRender={this.props.cardRender} />
        <ExtraCardBehavior>
          <FullScreenButton onClick={this.handleFullScreenClick} />
        </ExtraCardBehavior>
        <Modal
          isOpen={this.state.isOpen}
          onRequestModalClose={this.handleRequestModalClose}
        >
          <FullScreenModalHeader onClick={this.handleRequestModalClose} />
          <FullScreenIframe src={`/mason/kpi/${this.props.card.id}`} />
        </Modal>
      </div>
    );
  }
}

Mason.defaultProps = {
  style: {},
  frameStyle: {},
};

Mason.propTypes = {
  card: PropTypes.object.isRequired,
  frameStyle: PropTypes.object.isRequired,
  style: PropTypes.object,
};

export default Mason;
